import React from 'react';
import { Box, Button, FormControl, FormControlLabel, Input, InputAdornment, InputLabel, MenuItem, Select, SelectChangeEvent, Switch, TextField } from "@mui/material";
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { LandingZone, Partner } from '@m4a3/api-client';
import { merchantCategories } from '../../../constants/merchantConstants';

interface StoreInfoDialogContentProps {
  setPosName:  (value: React.SetStateAction<string>) => void;
  posName: string;
  fdAppId: number;
  setfdAppId:  (value: React.SetStateAction<number>) => void;
  fdMenuId: number;
  setfdMenuId:  (value: React.SetStateAction<number>) => void;
  fdStoreId: number;
  setfdStoreId:  (value: React.SetStateAction<number>) => void;
  deliveryFeeDisplayValue: string;
  setDeliveryFeeDisplayValue:  (value: React.SetStateAction<string>) => void;
  setImage:  (value: React.SetStateAction<File>) => void;
  logo: string;
  isValidImage: (file: File) => boolean;
  setLargeImage:  (value: React.SetStateAction<File>) => void;
  largeLogo: string;
  setOrderInList:  (value: React.SetStateAction<number>) => void;
  sortOrder: number;
  setLeadTime:  (value: React.SetStateAction<number>) => void;
  leadTime: number;
  onChangeOrderThrottling: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>;
  orderHrLimit: number;
  partnerId: number | null;
  onChangePartner: (event: SelectChangeEvent<number>, child: React.ReactNode) => void;
  partners: Partner[];
  displayStore: boolean;
  handleSwitchAddStore: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  openNow: boolean;
  setOpenNow:  (value: React.SetStateAction<boolean>) => void;
  preorderAvail: boolean;
  setPreorderAvail:  (value: React.SetStateAction<boolean>) => void;
  notify: (data: { variant: string; message: string }) => void;
  landingZones: LandingZone[];
  landingZoneId: string | null;
  setLandingZoneId: (value: React.SetStateAction<string>) => void;
  category: string | null;
  setCategory: (value: React.SetStateAction<string>) => void;
  autoAcceptEnabled: boolean;
  setAutoAcceptEnabled:(value: React.SetStateAction<boolean>) => void;
  autoPreparingEnabled: boolean;
  setAutoPreparingEnabled:(value: React.SetStateAction<boolean>) => void;
  autoPreparedEnabled: boolean;
  setAutoPreparedEnabled:(value: React.SetStateAction<boolean>) => void;
  travelTime: number;
  setTravelTime: (value: React.SetStateAction<number>) => void;
}

export const StoreInfoDialogContent = ({setPosName,
    posName,
    fdAppId,
    setfdAppId,
    fdMenuId,
    setfdMenuId,
    fdStoreId,
    setfdStoreId,
    deliveryFeeDisplayValue,
    setDeliveryFeeDisplayValue,
    setImage,
    logo,
    isValidImage,
    setLargeImage,
    largeLogo,
    setOrderInList,
    sortOrder,
    setLeadTime,
    leadTime,
    onChangeOrderThrottling,
    orderHrLimit,
    partnerId,
    onChangePartner,
    partners,
    displayStore,
    handleSwitchAddStore,
    openNow,
    setOpenNow,
    preorderAvail,
    setPreorderAvail,
    notify,
    landingZones,
    landingZoneId,
    setLandingZoneId,
    category,
    setCategory,
    autoAcceptEnabled,
    setAutoAcceptEnabled,
    autoPreparingEnabled,
    setAutoPreparingEnabled,
    autoPreparedEnabled,
    setAutoPreparedEnabled,
    travelTime,
    setTravelTime,
  }: StoreInfoDialogContentProps) => {
  return (<>
    <Button
      size="small"
      variant="contained"
      onClick={() => {
        window.open(
          `https://fd.manna.aero/?eircode=CYAN&appLaunch=true&fdAppId=${fdAppId}`,
          'blank'
        );
      }}>
      View Store
    </Button>
    <Button
      size="small"
      variant="contained"
      style={{ marginLeft: 5 }}
      onClick={() => {
        window.open(
          `https://portal.flipdish.com/${fdAppId}/menus/${fdMenuId}`,
          'blank'
        );
      }}>
      Edit Menu on flipdish
    </Button>
    <TextField
      fullWidth
      label="Name"
      style={{
        marginTop: 10
      }}
      onChange={e => setPosName(e.target.value)}
      value={posName}
    />
    <FormControl fullWidth style={{
        marginTop: 10
      }}>
      <InputLabel htmlFor="store-fd-app-id-input">
        App ID (e.g fd2952)
      </InputLabel>
      <Input
        id='store-fd-app-id-input'
        value={fdAppId}
        onChange={e => {
          const idNum = parseInt(e.target.value);
          if (idNum) {
            setfdAppId(idNum);
          }
        }}
        startAdornment={
          <InputAdornment position="start">fd</InputAdornment>
        }
      />
    </FormControl>
    <FormControl fullWidth style={{
        marginTop: 10
      }}>
      <InputLabel htmlFor="store-fd-menu-id-input">
        FD Menu ID
      </InputLabel>
      <Input
        id='store-fd-menu-id-input'
        value={fdMenuId}
        onChange={e => {
          const idNum = parseInt(e.target.value);
          if (idNum) {
            setfdMenuId(idNum);
          } else {
            setfdMenuId(null);
          }
        }}
      />
    </FormControl>
    <FormControl fullWidth style={{
        marginTop: 10
      }}>
      <InputLabel htmlFor="store-fd-store-id-input">
        FD Store ID
      </InputLabel>
      <Input
        id='store-fd-store-id-input'
        value={fdStoreId}
        onChange={e => {
          const idNum = parseInt(e.target.value);
          if (idNum) {
            setfdStoreId(idNum);
          } else {
            setfdStoreId(null);
          }
        }}
      />
    </FormControl>
    <FormControl fullWidth style={{
        marginTop: 10
      }}>
      <InputLabel htmlFor="store-delivery-fee-input">
        Delivery fee (e.g.: 4.20)
      </InputLabel>
      <Input
        id='store-delivery-fee-input'
        value={deliveryFeeDisplayValue}
        onChange={e => {
          setDeliveryFeeDisplayValue(e.target.value);
        }}
      />
    </FormControl>
    <FormControl fullWidth>
      <InputLabel>Logo</InputLabel>
      <Box
        style={{
          left: 0,
          marginTop: 8,
          paddingLeft: 10,
          paddingTop: 32,
          paddingBottom: 16,
          flexDirection: 'row',
          display: 'flex'
        }}>
        <Box>
          <input
            type="file"
            accept="image/*"
            title=" "
            style={{
              paddingTop: 8,
              paddingBottom: 8,
              width: 84,
              overflow: 'hidden'
            }}
            onChange={e => {
              if (isValidImage(e.target.files[0])) {
                setImage(e.target.files[0]);
              } else {
                setImage(null);
                notify({
                  variant: 'error',
                  message:
                    'Please provide a valid image file and is under 8mb in size'
                });
              }
            }}
          />
        </Box>

        <Box style={{ width: 400, paddingTop: 0, paddingLeft: 200 }}>
          {logo ? (
            <DoneIcon
              color="success"
              style={{ height: '100%', marginLeft: 8 }}
            />
          ) : (
            <ClearIcon
              color="error"
              style={{ height: '100%', marginLeft: 8 }}
            />
          )}
        </Box>
      </Box>
      {logo && (
        <Box style={{ paddingTop: 0 }}>
          {' '}
          <label>{logo}</label>
        </Box>
      )}
    </FormControl>
    <FormControl fullWidth>
      <InputLabel>Large logo</InputLabel>
      <Box
        style={{
          left: 0,
          marginTop: 8,
          paddingLeft: 10,
          paddingTop: 32,
          paddingBottom: 16,
          flexDirection: 'row',
          display: 'flex'
        }}>
        <Box>
          <input
            type="file"
            accept="image/*"
            style={{
              paddingTop: 8,
              paddingBottom: 8,
              width: 84,
              overflow: 'hidden'
            }}
            onChange={e => {
              if (isValidImage(e.target.files[0])) {
                setLargeImage(e.target.files[0]);
              } else {
                setLargeImage(null);
                notify({
                  variant: 'error',
                  message:
                    'Please provide a valid image file and is under 8mb in size'
                });
              }
            }}
          />
        </Box>

        <Box style={{ width: 400, paddingTop: 0, paddingLeft: 200 }}>
          {largeLogo ? (
            <DoneIcon
              color="success"
              style={{ height: '100%', marginLeft: 8 }}
            />
          ) : (
            <ClearIcon
              color="error"
              style={{ height: '100%', marginLeft: 8 }}
            />
          )}
        </Box>
      </Box>
      {largeLogo && (
        <Box style={{ paddingBottom: 16, paddingTop: 0 }}>
          {' '}
          <label>{largeLogo}</label>
        </Box>
      )}
    </FormControl>
    <TextField
      fullWidth
      label="Position"
      type="number"
      style={{
        marginTop: 10
      }}
      onChange={e => {
        setOrderInList(parseInt(e.target.value));
      }}
      value={sortOrder}
    />
    <TextField
      fullWidth
      label="Lead Time"
      type="number"
      style={{
        marginTop: 10
      }}
      onChange={e => {
        setLeadTime(parseInt(e.target.value));
      }}
      value={leadTime}
    />
    <TextField
      fullWidth
      label="Travel Time"
      type="number"
      style={{
        marginTop: 10
      }}
      onChange={e => {
        setTravelTime(parseInt(e.target.value));
      }}
      value={travelTime}
    />
    <TextField
      type="number"
      fullWidth
      label="Order throttling (orders per hour)"
      style={{
        marginTop: 10
      }}
      onChange={onChangeOrderThrottling}
      value={orderHrLimit}
    />
    <span>Set to 0 for no limit. Tesco's exclusive limit is 9999</span>
    <FormControl
      style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>
      <InputLabel>Partner ID</InputLabel>
      <Select value={partnerId} onChange={onChangePartner} label="">
        {partners &&
          partners.map(p => {
            const partnerName = `${p?.partnerName[0].toUpperCase()}${p.partnerName.slice(
              1,
              p.partnerName.length
            )}`;
            return (
              <MenuItem key={`partner-name-${p.id}`} value={p.id}>
                {partnerName}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
    <FormControl
      style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>
      <InputLabel>Category</InputLabel>
      <Select value={category} onChange={(e) => setCategory(e.target.value)} label="">
        {merchantCategories &&
          merchantCategories.map(cat => {
            return (
              <MenuItem key={`merchant-category-${cat.value}`} value={cat.value}>
                {cat.displayText}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
    <FormControl
      style={{ width: '100%', marginTop: 20, marginBottom: 20 }}>
      <InputLabel>Landing Zone</InputLabel>
      <Select value={landingZoneId} onChange={(e) => setLandingZoneId(e.target.value)} label="">
        {landingZones&&
          landingZones.map(lz => {
            return (
              <MenuItem key={`landing-pad-zone-${lz.id}`} value={lz.id}>
                {lz.name}
              </MenuItem>
            );
          })}
      </Select>
    </FormControl>
    <FormControlLabel
      style={{
        marginTop: 10
      }}
      label="Auto Accept"
      control={
        <Switch
          checked={autoAcceptEnabled}
          onChange={evt => {
            setAutoAcceptEnabled(evt.target.checked);
          }}
          color="primary"
        />
      }
    />
    <FormControlLabel
      style={{
        marginTop: 10
      }}
      label="Auto Prepare"
      control={
        <Switch
          checked={autoPreparingEnabled}
          onChange={evt => {
            setAutoPreparingEnabled(evt.target.checked);
          }}
          color="primary"
        />
      }
    />
    <FormControlLabel
      style={{
        marginTop: 10
      }}
      label="Auto Ready"
      control={
        <Switch
          checked={autoPreparedEnabled}
          onChange={evt => {
            setAutoPreparedEnabled(evt.target.checked);
          }}
          color="primary"
        />
      }
    />
    <FormControlLabel
      style={{
        marginTop: 10
      }}
      label="Display Store"
      control={
        <Switch
          checked={displayStore}
          onChange={handleSwitchAddStore}
          color="primary"
        />
      }
    />
    <FormControlLabel
      style={{
        marginTop: 10
      }}
      label="Store Open"
      control={
        <Switch
          checked={openNow}
          onChange={evt => {
            setOpenNow(evt.target.checked);
          }}
          color="primary"
        />
      }
    />
    <FormControlLabel
      style={{
        marginTop: 10
      }}
      label="Preorder Avail"
      control={
        <Switch
          checked={preorderAvail}
          onChange={evt => {
            setPreorderAvail(evt.target.checked);
          }}
          color="primary"
        />
      }
    />
  </>);
};
